import { z } from "zod";
import { Vendor } from "./vendorConfig";

export const UUID_MESSAGE = "Invalid UUID format.";
export const AXON_DOMAIN = /^[a-z0-9-]+\.evidence\.com$/i;
export const LENSLOCK_DOMAIN = /^[a-z0-9-]+\.lenslock\.io$/i;
export const HOSTNAME_REGEX =
  /^(?=.{1,253}(?:\/|$))(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.(?!-)[A-Za-z0-9-]{1,63}(?<!-))*(?:\/[^\s/?#]+)*\/?(?:\?[^\s#]*)?(?:#[^\s]*)?$/;

export type CredentialsFormValues = {
  clientId?: string;
  clientSecret: string;
  apiUrl: string;
  agencyId?: string;
  tenantName?: string;
};

export const schemaByVendor = (vendor: Vendor) => {
  const clientSecret = z.string().trim().min(1, "Required");
  const apiUrlByVendor =
    vendor === "AXON"
      ? z
          .string()
          .trim()
          .min(1, "Required")
          .regex(AXON_DOMAIN, "Use youragency.evidence.com")
      : vendor === "LENSLOCK"
      ? z
          .string()
          .trim()
          .min(1, "Required")
          .regex(LENSLOCK_DOMAIN, "Use youragency.lenslock.io")
      : z
          .string()
          .trim()
          .min(1, "Required")
          .regex(
            HOSTNAME_REGEX,
            "Enter a valid host (e.g., example.azure-api.us)"
          );

  if (vendor === "AXON") {
    return z.object({
      clientId: z.string().trim().uuid(UUID_MESSAGE),
      clientSecret,
      apiUrl: apiUrlByVendor,
      agencyId: z.string().trim().uuid(UUID_MESSAGE),
      tenantName: z.string().optional(),
    });
  }

  if (vendor === "LENSLOCK") {
    return z.object({
      clientId: z.string().trim().uuid(UUID_MESSAGE),
      clientSecret,
      apiUrl: apiUrlByVendor,
      agencyId: z.string().trim().uuid(UUID_MESSAGE),
      tenantName: z.string().trim().min(1, "Required"),
    });
  }

  return z.object({
    clientSecret,
    apiUrl: apiUrlByVendor,
  });
};
